<template>
<section class="component-data-list">
    <main-layout>
        <!-- BEGIN: Content-->
                <div class="content-body">
                    <!-- Input Sizing start -->
                    <section id="input-sizing">
                        <div class="row match-height">
                            <div class="col-md-4 col-md-offset-4 m-auto">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">Change Password</h4>
                                    </div>
                                    <div class="card-body wait_me_insert_form">
                                        <div class="form-row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="old_password">Old password <span class="text-danger">*</span></label>
                                                    <input type="password" v-model="form.user.old_password" class="form-control" id="old_password" placeholder="Enter old password" @keyup.enter="resetPassword()" autocomplete="off"/>
                                                </div>
                                                <!-- <div class="form-group">
                                                    <label for="password">New password <span class="text-danger">*</span></label>
                                                    <input type="password" v-model="form.user.password" class="form-control" id="password" placeholder="Enter new password" v-on:keyup="password_validation_check()" @keyup.enter="resetPassword()" autocomplete="off"/>
                                                </div>
                                                <div class="form-group">
                                                    <label for="confirm_password">Confirm password <span class="text-danger">*</span></label>
                                                    <input type="password" v-model="form.user.confirm_password" class="form-control" id="confirm_password" placeholder="Enter confirm password" v-on:keyup="password_validation_check()" @keyup.enter="resetPassword()" autocomplete="off"/>
                                                </div> -->
                                                <div class="form-group">
                                                    <div class="d-flex justify-content-between">
                                                        <label>Password <span class="text-danger">*</span></label>
                                                    </div>
                                                    <div class="input-group input-group-merge form-password-toggle">
                                                        <input class="form-control form-control-merge"
                                                            :type="isPasswordVisible ? 'text' : 'password'"
                                                            v-model="form.user.password" @keyup="localPasswordCheck" />
                                                        <div class="input-group-append"><span
                                                                class="input-group-text cursor-pointer"
                                                                @click="togglePasswordVisibility"><i class="fa"
                                                                    :class="{ 'fa-eye': isPasswordVisible, 'fa-eye-slash': !isPasswordVisible }"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="d-flex justify-content-between">
                                                        <label>Confirm Password <span class="text-danger">*</span></label>
                                                    </div>
                                                    <div class="input-group input-group-merge form-password-toggle">
                                                        <input class="form-control form-control-merge"
                                                            :type="isConfirmPasswordVisible ? 'text' : 'password'"
                                                            v-model="form.user.confirm_password"
                                                            @keyup="localPasswordCheck" />
                                                        <div class="input-group-append"><span
                                                                class="input-group-text cursor-pointer"
                                                                @click="toggleConfirmPasswordVisibility"><i class="fa"
                                                                    :class="{ 'fa-eye': isConfirmPasswordVisible, 'fa-eye-slash': !isConfirmPasswordVisible }"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <span>
                                                        <check-icon size="1.5x" class="custom-class text-success" v-if="errorMessages.character"></check-icon>
                                                        <x-icon size="1.5x" class="custom-class text-warning" v-if="!errorMessages.character"></x-icon>
                                                        At least 8 character long.
                                                    </span><br>
                                                    <span>
                                                        <check-icon size="1.5x" class="custom-class text-success" v-if="errorMessages.lowercase"></check-icon>
                                                        <x-icon size="1.5x" class="custom-class text-warning" v-if="!errorMessages.lowercase"></x-icon>
                                                        One lowercase character
                                                    </span><br>
                                                    <span>
                                                        <check-icon size="1.5x" class="custom-class text-success" v-if="errorMessages.uppercase"></check-icon>
                                                        <x-icon size="1.5x" class="custom-class text-warning" v-if="!errorMessages.uppercase"></x-icon>
                                                        One uppercase character
                                                    </span><br>
                                                    <span>
                                                        <check-icon size="1.5x" class="custom-class text-success" v-if="errorMessages.number"></check-icon>
                                                        <x-icon size="1.5x" class="custom-class text-warning" v-if="!errorMessages.number"></x-icon>
                                                        One Number
                                                    </span><br>
                                                    <span>
                                                        <check-icon size="1.5x" class="custom-class text-success" v-if="errorMessages.symbol"></check-icon>
                                                        <x-icon size="1.5x" class="custom-class text-warning" v-if="!errorMessages.symbol"></x-icon>
                                                        One special character
                                                    </span><br>
                                                    <span>
                                                        <check-icon size="1.5x" class="custom-class text-success" v-if="errorMessages.confirm_password"></check-icon>
                                                        <x-icon size="1.5x" class="custom-class text-warning" v-if="!errorMessages.confirm_password"></x-icon>
                                                        Confirm password not match.
                                                    </span>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col text-right">
                                                        <button type="button" class="btn btn-success" @click.prevent="resetPassword()">Update Password</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- Input Sizing end -->
                </div>
        <!-- END: Content-->


        <div class="sidenav-overlay"></div>
        <div class="drag-target"></div>
    </main-layout>
</section>
</template>

<script>
import MainLayout from './MainLayout.vue';
import feather from 'feather-icons';
// import swal from 'bootstrap-sweetalert';
// import { EditIcon } from 'vue-feather-icons'
// import { AlertTriangleIcon } from 'vue-feather-icons'
import { CheckIcon, XIcon } from 'vue-feather-icons'

export default{
    name: 'ChangePassword',
    metaInfo: {
        titleTemplate: 'University of Lancashire | Change Password'
    },
    components:{
        MainLayout,
        CheckIcon, XIcon
        // EditIcon,
    },
    data:()=>{
        return {
            saveData: true,
            showModal: false,
            icon: 'edit',
            flag:{
                show_modal_form:false
            },
            form: {
                user: {
                    name: '',
                    email: '',
                    old_password: '',
                    password: '',
                    confirm_password: '',
                }
            },
            isPasswordVisible: false,
            isOldPasswordVisible: false,
            isConfirmPasswordVisible: false,
            errorMessages: {}
        };
    },
    computed: {
    },
    created: async function () {
        this.setup_urls();
    },
    methods:{
        toggleOldPasswordVisibility: function (event) {
            this.isOldPasswordVisible = !this.isOldPasswordVisible;
            event.target.type = this.isOldPasswordVisible ? 'text' : 'password';
        },
        togglePasswordVisibility: function (event) {
            this.isPasswordVisible = !this.isPasswordVisible;
            event.target.type = this.isPasswordVisible ? 'text' : 'password';
        },
        toggleConfirmPasswordVisibility: function (event) {
            this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
            event.target.type = this.isConfirmPasswordVisible ? 'text' : 'password';
        },
        localPasswordCheck() {
            let pwd = this.form.user.password;
            let confirmPwd = this.form.user.confirm_password;

            this.errorMessages = {
                character: pwd.length >= 8,
                lowercase: /[a-z]/.test(pwd),
                uppercase: /[A-Z]/.test(pwd),
                number: /\d/.test(pwd),
                symbol: /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
                no_space: pwd.length > 0 && !/\s/.test(pwd),
                confirm_password: pwd === confirmPwd && confirmPwd.length > 0
            };

            // Return true if all pass
            return Object.values(this.errorMessages).every(v => v === true);
        },
        password_validation_check: async function () {

            var ref=this;
            var jq=ref.jq();
            try{
                var res = await jq.post(ref.url('api/v1/agent/auth/password_validation_check'), ref.form.user);
                ref.errorMessages = res
                // console.log('errorMessages', ref.errorMessages)
            } catch (err) {
                ref.alert(ref.err_msg(err), 'error');
            }
        },
        resetPassword: async function () {

            var ref=this;
            var jq=ref.jq();
            try{
                ref.wait_me('.wait_me_insert_form');
                var res = await jq.post(ref.url('api/v1/agent/ajax/reset_user_password_uclan_agent'), ref.form.user);
                localStorage.removeItem('agent_api_token')
                this.$router.push('/dashboard')
                ref.alert(res.msg);

            } catch (err) {
                ref.alert(ref.err_msg(err), 'error');
            }
            finally {
                ref.wait_me('.wait_me_insert_form', 'hide');
            }
        },
    },
    mounted: function(){
        feather.replace();
    }
}
</script>

<style scoped>
    /* .regional-form-section {
        min-height: 100% !important;
    } */

</style>